// extracted by mini-css-extract-plugin
module.exports = {"container":"InteriorDesign_container__5bnkO","button1":"InteriorDesign_button1__1HpvA","button2":"InteriorDesign_button2__iw_nq"};